import React from "react";
import { connect } from "react-redux";
import { Card, CardBody, Col, DropdownItem, Row } from "reactstrap";
import {
  ActionsRow,
  FixedDropDownButton,
  HorizontalLoader,
  Icon,
  InfiniteScroll,
  Loader,
  modal,
  utils,
} from "@mc/mc-legacy";
import QSignAdminApi from "../../../api/gen/qsign/QSignAdminApi";
import * as textNoteActions from "../../../actions/textNoteActions";
import { DetailValue } from "@mc/mc-legacy";
import TextNoteForm from "../../forms/TextNoteForm";

class TextNoteList extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props, force = false) => {
    props.dispatch(textNoteActions.fetchTextNotesIfNeeded(force));
  };

  handleEditConfig = (item) => {
    const { dispatch } = this.props;
    const { steps, ...other } = item;

    dispatch(
      modal.ModalActions.show(
          TextNoteForm,
        {
          onSubmit: (data) => {
            return QSignAdminApi.updateTextNote(data.id, data);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(textNoteActions.fetchTextNotesIfNeeded(true));
          },
          initialValues: {
             ...other,
          },
        },
        "Úprava poznámky",
        {}
      )
    );
  };
  handleDeleteConfig = (item) => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showConfirm(
        "Potvrzení smazání",
        "Opravdu chcete poznámku smazat?",
        () =>
          QSignAdminApi.deleteTextNote(item.id).then(() => {
            dispatch(textNoteActions.fetchTextNotesIfNeeded(true));
          }),
        null,
        "Potvrdit"
      )
    );
  };
  renderItem = (item, key) => {
    return (
      <Card key={key}>
        <CardBody>
          <ActionsRow actions={this.renderActions(item)}>
            <Row>
              <Col xs={12} md={4}>
                <DetailValue textOverflow label="Poznámka" valueTitle={item.note}>
                    {item.note}
                </DetailValue>
              </Col>
            </Row>
          </ActionsRow>
        </CardBody>
      </Card>
    );
  };
  renderActions = (item) => {
    return (
      <Col className="item-actions">
        <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v" className="item-actions-icon" />}>
          <DropdownItem key="1" onClick={() => this.handleEditConfig(item)}>
            Upravit
          </DropdownItem>
          <DropdownItem key="2" onClick={() => this.handleDeleteConfig(item)}>
            Smazat
          </DropdownItem>
        </FixedDropDownButton>
      </Col>
    );
  };

  render() {
    const { textNoteList } = this.props;

    if (!textNoteList) {
      return <Loader />;
    }
    return (
      <InfiniteScroll className="text-note-list" bordered>
        {textNoteList.isFetching && <HorizontalLoader key={'loader'} hover />}
        {textNoteList.rows.map((item, key) => {
          return this.renderItem(item, key);
        })}
      </InfiniteScroll>
    );
  }
}

function mapStateToProps(state) {
  return {
      textNoteList: utils.storeFromArea(state, textNoteActions.TEXT_NOTE_LIST),
  };
}

export default connect(mapStateToProps)(TextNoteList);
